/**
 * Normalize flag image URLs so the filename is lowercase (GB.svg → gb.svg).
 * Rewrites absolute /images/countries/ URLs to same-origin paths (CMS often
 * ships https://evignettehungary.com/... which 404s while local assets exist).
 * Leaves query/hash and file extension casing as-is.
 */
export function flagSrc(src) {
    let raw = String(src || "").trim();
    if (!raw) return "";

    try {
        if (/\/images\/countries\//i.test(raw)) {
            if (/^https?:\/\//i.test(raw)) {
                const u = new URL(raw);
                raw = `${u.pathname}${u.search}${u.hash}`;
            } else if (raw.startsWith("//")) {
                const u = new URL(`https:${raw}`);
                raw = `${u.pathname}${u.search}${u.hash}`;
            }
        }
    } catch (_) {
        /* keep raw */
    }

    const suffixMatch = raw.match(/([?#].*)$/);
    const suffix = suffixMatch ? suffixMatch[1] : "";
    const path = suffix ? raw.slice(0, -suffix.length) : raw;
    const slashIndex = path.lastIndexOf("/");
    const dir = slashIndex >= 0 ? path.slice(0, slashIndex + 1) : "";
    const filename = slashIndex >= 0 ? path.slice(slashIndex + 1) : path;
    const dotIndex = filename.lastIndexOf(".");

    if (dotIndex <= 0) {
        return `${dir}${filename.toLowerCase()}${suffix}`;
    }

    return `${dir}${filename.slice(0, dotIndex).toLowerCase()}${filename.slice(dotIndex)}${suffix}`;
}
